import { Link } from 'react-router-dom';
import styled from 'styled-components';
import colors from '../../config/colors';

const Card = styled.div`
    background-color: ${colors.WHITE};
    border: 1px solid ${colors.GRAY_LIGHT};
    min-height: 420px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    width: 100%;
    transition: all 600ms;
    margin: 0 0 20px;

    &:hover {
      border-color: rgb(99 64 152 / 54%);
      box-shadow: inset 0 0 200px rgb(99 64 152 / 24%);
    }
`;

const size: any = {
    event_img_size: {
        width: "240px",
    },
    job_img_size: {
        width: "150px",
    },
};

const CardImage = styled(Link)`
    box-sizing: border-box;
    border-bottom: 1px solid ${colors.GRAY_LIGHT};
    padding: 10px 24px;
    display: flex;
    align-items: center;

    img, svg {
        width: ${props => size[props.theme].width};
        height: 150px;
        margin: auto;
        object-fit: contain;
        object-position: center;
        padding: 3px;
    }
`;

const CardDescription = styled.div`
    padding: 33px 24px;

    h3 {
        font-size: 20px;
        line-height: 30px;
        color: ${colors.BLACK_COLOR};
        margin: 0;
    }

    p {
        line-height: 26px;
        color: ${colors.GRAY_DARK};
        word-break: break-word;
    }
`;

const CardFooter = styled.div`
    padding: 0 24px 16px 24px;
    margin-top: auto;

    div {
        white-space: nowrap;
    }

    span {
        font-size: 14px;
        line-height: 24px;
        color: ${colors.PRIMARY_PURPLE};
        font-family: "Gilroy-Medium";
        display: flex;
        align-items: center;

        a {
          font-size: 14px;
        }

        svg {
          stroke: ${colors.PURPLE_COLOR};
          margin-right: 5px;
          width: 14px;
          height: 14px;
        }
    }
`;

const CardCities = styled.div`
    margin-left: 5px;
    width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    span {
        font-family: 'Gilroy-Medium';
        color: ${colors.PRIMARY_PURPLE};
        display: inline-block;
        &:before {
            content: "/";
            display: inline-block;
            vertical-align: middle;
            margin: 0 5px;
        }

        &:first-of-type {
            &:before {
                display: none;
            }
        }
    }
`;

const CardDate = styled.div`
  font-family: 'Gilroy-Medium';
  font-size: 14px;
  line-height: 24px;
  color: ${colors.BLACK};
`;

const CardDateBold = styled.div`
  font-family: 'Gilroy-Bold';
  font-size: 14px;
  line-height: 24px;
  color: ${colors.BLACK_COLOR};
`;

const CardExtraSmall = styled.div`
    font-size: 20px;
    line-height: 26px;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    background-color: ${colors.WHITE};
    margin-bottom: 10px;
    border-radius: 3px;
    cursor: pointer;
    box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.07);
    font-family: "Gilroy-Medium";
    margin: 20px 0;

    h2 {
        margin-bottom: 0;
        font-size: 20px;
    }

    &:last-child {
        margin-bottom: 0;
    }

    span {
        display: flex;
    }

    svg {
        margin-right: 20px;
        width: 55px;
        height: 55px;
        fill: ${colors.PRIMARY_ORANGE};
    }
    .back {
        width: 40px;
        height: 18px;
    }
    &:hover {
        background-color: ${colors.PRIMARY_ORANGE};
        color: ${colors.WHITE};
        transition: all 100ms ease-in-out;
        h2 {
            color: ${colors.WHITE};
        }
        svg {
            fill: ${colors.WHITE};
        }
    }
`

const CardSmall = styled(Link)`
    font-family: 'Gilroy-Medium';
    font-size: 16px;
    line-height: 26px;
    padding: 33px 24px;
    display: flex;
    align-items: center;
    width: 100%;
    background-color: ${colors.WHITE};
    transition: all 400ms;
    box-shadow: 0px 3px 30px rgba(0, 0, 0 ,0.07);
    margin-bottom: 20px;
    color: ${colors.BLACK};
    border: 1px solid transparent;

    @media (max-width: 576px) {
      padding: 33px 15px;
    }

    span {
      display: flex;
      max-width: 175px;

      @media (max-width: 1400px) {
        max-width: 100%;
      }
    }

    svg {
      flex-shrink: 0;
      margin-right: 27px;
      width: 52px;
      height: 52px;

      @media (max-width: 576px) {
        margin-right: 15px;
      }
    }

    &:hover {
      background: rgb(99 64 152 / 10%);
      box-shadow: 0px 0px 0px 1px rgb(99 64 152 / 54%);
    }
`;


const theme: any = {
    gradient_orange: {
      background: "radial-gradient(50% 50% at 50% 50%, #FFD786 0%, #F6BF51 100%);",
      color: `${colors.WHITE}`
    },
    white: {
        background: `${colors.WHITE}`,
        color: `${colors.BLACK}`
    },
};

const CardBig = styled(Link)`
    background: ${props => theme[props.theme].background};
    min-width: 250px;
    min-height: 465px;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 0 20px;
    background: radial-gradient(#FFD786 var(--p),#F6BF51);
    --p: 10%;
    transition: --p 600ms;
    margin-bottom: 20px;

    @property --p {
      syntax: '<percentage>';
      inherits: false;
      initial-value: 10%;
    }

    span {
        color: ${props => theme[props.theme].color};
    }

    &:hover {
      background: radial-gradient(#ffdd99 var(--p),#F6BF51);
      --p: 100%;
    }
`;

CardBig.defaultProps = {
    theme: 'gradient_orange'
}

const CardBigImage = styled.div`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-left: 24px;

    img {
        display: block;
        object-fit: cover;
        object-position: center;
    }
`;

const CardBigDescription = styled.div`
    padding: 16px 24px;

    span {
        display: block;
        font-size: 12px;
        line-height: 22px;
        font-family: "Gilroy-Bold";
        margin: 0 0 20px;
    }

    h3 {
        font-size: 20px;
        line-height: 30px;
        margin: 0;
    }

    p {
        color: ${colors.BLACK_COLOR};
        word-break: break-word;
    }
`;

const CardBigDate = styled.div`
    font-size: 14px;
    line-height: 24px;

    span {
      display: block;
      font-family: "Gilroy-Medium";
      color: ${colors.BLACK_COLOR};
      white-space: pre-wrap;
    }
`;

export {
    Card,
    CardImage,
    CardDescription,
    CardFooter,
    CardCities,
    CardDate,
    CardDateBold,
    CardExtraSmall,
    CardSmall,
    CardBig,
    CardBigImage,
    CardBigDescription,
    CardBigDate,
};
